import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { CatalogItemKind } from 'fym-shared/src/smartlinks/catalog';
import { TypedMemo } from '../../../common/types';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import { useUpgradePrompt } from '../../hooks/useUpgradePrompt';
import { releaseMessages } from './releaseMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './ReleasePage.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * True when the release head shows the note: an unreleased song with no pre-save, on a plan with no
 * pre-save pages, and not the demo artist.
 */
export function showsPresavePlanNote(facts: {
  canUsePresave: boolean;
  isDemo: boolean;
  kind: CatalogItemKind;
  presaveCampaignUuid: string | null;
}): boolean {
  return (
    !facts.canUsePresave &&
    !facts.isDemo &&
    facts.kind === CatalogItemKind.unreleased &&
    facts.presaveCampaignUuid === null
  );
}

/**
 * The note under the release head of an unreleased song on a plan with no pre-save pages (Free):
 * what the plan is missing and the way to it (onboarding review 2026-10-19). "See plans" opens the
 * plan prompt of the pre-save feature.
 */
const ReleasePresavePlanNoteComponent: React.FC = () => {
  const intl = useIntl();
  const openUpgradePrompt = useUpgradePrompt();
  const openPlans = useCallback(() => openUpgradePrompt(SMLUpgradeFeature.presave), [openUpgradePrompt]);
  return (
    <p className={styles.planNote} data-testid="release-presave-plan-note">
      <FontAwesomeIcon icon={faLock} />
      <span>{intl.formatMessage(releaseMessages.presaveNeedsPlan)}</span>
      <button type="button" className={styles.planNoteLink} onClick={openPlans}>
        {intl.formatMessage(releaseMessages.presaveSeePlans)}
      </button>
    </p>
  );
};

export const ReleasePresavePlanNote = TypedMemo(ReleasePresavePlanNoteComponent);
